import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  Currency,
  CurrencyRate,
  SaveCurrencyRatePayload,
  SaveCurrencyRateResult,
} from '../models/currency.model';
import { PeriodMode } from '../models/period.model';

@Injectable({ providedIn: 'root' })
export class CurrencyApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiBaseUrl}/api/currency`;

  list(): Observable<Currency[]> {
    return this.http.get<Currency[]>(this.baseUrl);
  }

  rates(monthId: number, mode: PeriodMode): Observable<CurrencyRate[]> {
    const params = new HttpParams().set('monthId', monthId).set('mode', mode);
    return this.http.get<CurrencyRate[]>(`${this.baseUrl}/rates`, { params });
  }

  save(payload: SaveCurrencyRatePayload): Observable<SaveCurrencyRateResult> {
    return this.http.patch<SaveCurrencyRateResult>(
      `${this.baseUrl}/rates`,
      payload
    );
  }
}
